"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAffiliate = void 0;
function mockAffiliate(overrides = {}) {
    return {
        campaign_source: 'mock_campaign_source',
        cookie_expiration: 0,
        ...overrides,
    };
}
exports.mockAffiliate = mockAffiliate;
